<template>
  <v-dialog v-model="dialog" max-width="560">
      <template #activator="{on}">
          <v-btn v-on="on" outlined color="accent" class="mr-2">Add Set</v-btn>
      </template>
      <v-card>
          <v-card-title>Add Set on Purchase Order</v-card-title>
          <v-card-text>
               <v-form ref="addForm">
                    <SetAutocomplete v-model="model.product_id" @setSelected="setProducts($event)" :rules="[rules.required]" />
                    <v-text-field v-model="model.quantity" label="Quantity" :rules="[rules.required]" />
                    <v-text-field v-model="model.cost" label="Unit Cost" :suffix="currency" />
               </v-form>
          </v-card-text>
          <v-card-actions>
              <v-btn @click="close">Close</v-btn>
              <v-spacer></v-spacer>
              <v-btn @click="add">Add</v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import SetAutocomplete from "../forms/autocomplete/Set.vue"
export default {
    name:"AddProduct",
    components:{
        SetAutocomplete
    },
    data: () => ({
        dialog:false,
        model:{},
        product:null,
        
        rules: {
            required: value => !!value || "This field is mandatory.",
        },
        set:null
    }),
    props:{
        currency:{
            type:String,
            default:''
        }
    },
    methods:{
        close(){
            this.model={}
            this.dialog=false
        },
        add(){
            if (this.$refs.addForm.validate()) {
                for (let idx = 0; idx < this.set.products.length; idx++) {
                    const product = this.set.products[idx];

                    let model = {
                        product: product,
                        product_id: product.id,
                        quantity: parseInt(this.model.quantity),
                        cost: parseInt(this.model.cost),
                    }
                    this.$emit("added", model);
                }
                this.model={}
                this.$refs.addForm.reset()
                this.$refs.addForm.resetValidation()
            }
        },
        setProducts(set)
        {
            this.set = set
        }
    }
}
</script>

<style>

</style>